import React from "react";
import TeamRosterTable from "./TeamRosterTable";
import ReportProgramsPage from "../../components/ReportProgramsPage";

const TeamRosterIndex = () => (
  <ReportProgramsPage
    TableComponent={TeamRosterTable}
    loadingMessage="Loading team roster summary..."
  />
);

export default TeamRosterIndex;
